import { ReactNode } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
// eslint-disable-next-line import/no-cycle
import { useChakraTheme } from './useChakraTheme.hooks';
import ThemeProvider, { KoddiTheme } from '../../ThemeProvider';

export const ChakraTheme = ({
    children,
    theme,
    hasEmbeddedStyles = false,
}: {
    children: ReactNode;
    theme?: KoddiTheme;
    hasEmbeddedStyles?: boolean;
}): JSX.Element => {
    const chakraCustomTheme = useChakraTheme(hasEmbeddedStyles);
    return (
        <ThemeProvider theme={theme}>
            <ChakraProvider theme={chakraCustomTheme}>
                {children}
            </ChakraProvider>
        </ThemeProvider>
    );
};
